import Backbone from 'backbone';
import Api from '@/lib/api/api';

    var v3_model = Backbone.Model.extend({
        parse: function(data, options) {
            var model = data;
            model.id = data.external_id;
                   return model;
            }
        });
    // Create a collection for old world IDE_Models
    var v3_models = new Backbone.Collection();
    v3_models.model = v3_model;
    v3_models.url = function(){
        return Api.urls.v3_models();
    };
    v3_models.sync = Api.generate_sync();

    export default v3_models;

